import { render, staticRenderFns } from "./ButtonRecoverPassMobile.vue?vue&type=template&id=b6d205da&"
import script from "./ButtonRecoverPassMobile.vue?vue&type=script&lang=js&"
export * from "./ButtonRecoverPassMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports